export default "__VITE_PUBLIC_ASSET__2a8a9c46__"